/**
 * wenskaartje-widget.js
 * Ansugifts — Dawn theme
 *
 * Aanvinken toont de textarea.
 * Kaartje wordt toegevoegd NADAT het hoofdproduct aan de cart is toegevoegd,
 * door te luisteren naar de 'cart-update' event van Dawn (PUB_SUB_EVENTS.cartUpdate).
 */

(function () {
  'use strict';

  function initWidget(widget) {
    var variantId = widget.dataset.variantId;
    if (!variantId) {
      console.warn('[Wenskaartje] Geen variant ID gevonden.');
      return;
    }

    var toggle         = widget.querySelector('#wenskaartjeToggle');
    var checkbox       = widget.querySelector('#wenskaartjeCheckbox');
    var body           = widget.querySelector('#wenskaartjeBody');
    var textarea       = widget.querySelector('#wenskaartjeBericht');
    var counter        = widget.querySelector('#wenskaartjeCounter');

    // Voorkom auto-zoom op iOS: Safari zoomt in als font-size < 16px bij focus.
    if (parseFloat(window.getComputedStyle(textarea).fontSize) < 16) {
      textarea.style.fontSize = '16px';
    }

    // Normaliseer de placeholder: nl.json heeft '[[ count ]]' (met spaties),
    // maar replace zoekt naar '[[count]]' zonder spaties — hierdoor werd nooit
    // vervangen en bleef de letterlijke tekst zichtbaar.
    var counterPattern = (widget.dataset.counterPattern || '[[count]] / 250')
      .replace(/\[\[\s*count\s*\]\]/g, '[[count]]');

    var isActive  = false;
    var isPending = false; // voorkomt dubbel toevoegen
    var armed     = false; // wordt 'true' na ATC-klik; gewacht wordt op Dawn's bevestiging

    // --- Toggle: tonen/verbergen ---
    toggle.addEventListener('click', function () {
      isActive = !isActive;
      toggle.setAttribute('aria-expanded', String(isActive));
      checkbox.classList.toggle('checked', isActive);

      if (isActive) {
        body.removeAttribute('hidden');
        counter.textContent = counterPattern.replace('[[count]]', 0);
        textarea.focus();
      } else {
        body.setAttribute('hidden', '');
        textarea.value = '';
        counter.textContent = counterPattern.replace('[[count]]', 0);
        counter.classList.remove('wenskaartje-counter--warn');
      }
    });

    // --- Tekenteller ---
    textarea.addEventListener('input', function () {
      var len = textarea.value.length;
      counter.textContent = counterPattern.replace('[[count]]', len);
      counter.classList.toggle('wenskaartje-counter--warn', len > 220);
    });

    // --- Kaartje toevoegen via fetch ---
    function addKaartje() {
      isPending = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {
            'Persoonlijk bericht': textarea.value.trim() || '(geen bericht)'
          }
        })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        isPending = false;
        // Kaching Cart vernieuwen als API beschikbaar is, anders Dawn cart:refresh
        if (window.kachingCartApi && typeof window.kachingCartApi.refresh === 'function') {
          window.kachingCartApi.refresh();
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      })
      .catch(function (err) {
        console.error('[Wenskaartje] Fout bij toevoegen:', err);
        isPending = false;
      });
    }

    // --- ATC detectie ---
    var atcButton = document.querySelector('[name="add"]');

    if (atcButton) {
      // Stap 1: 'bewapen' de widget zodra de klant op ATC klikt
      atcButton.addEventListener('click', function () {
        if (isActive && !isPending) {
          armed = true;
        }
      });

      // Stap 2: luister naar Dawn's 'cart-update' (PUB_SUB_EVENTS.cartUpdate).
      // product-form.js publiceert dit event pas NA een succesvolle cart add,
      // dus het kaartje wordt nooit toegevoegd als het hoofdproduct mislukt.
      if (typeof subscribe === 'function') {
        subscribe('cart-update', function (data) {
          if (!armed) return;
          if (data && data.source !== 'product-form') return;
          armed = false;
          addKaartje();
        });

        // Reset armed als de add mislukt (bijv. uitverkocht)
        subscribe('cart-error', function () {
          armed = false;
        });
      } else {
        // Fallback als Dawn's pubsub niet beschikbaar is
        atcButton.addEventListener('click', function () {
          if (!isActive || isPending) return;
          setTimeout(addKaartje, 1000);
        });
      }
    } else {
      console.warn('[Wenskaartje] ATC knop niet gevonden.');
    }
  }

  function init() {
    document.querySelectorAll('#wenskaartjeWidget').forEach(function (w) {
      initWidget(w);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();